import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';

import { ComplianceTermsRegisterHistory } from './registerHistory';
import { useComplianceTermsForm } from '../hook';
import { ComplianceTermsData } from './data';
import { ComplianceTermsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    COMPLIANCE_TERMS_EDIT,
    COMPLIANCE_TERMS_NEW,
    COMPLIANCE_TERMS,
} from '../../../../../routes/paths';

export const ComplianceTermsDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const {
        complianceTerms,
        setformikComplianceTermsData,
        complianceTermsHistorical,
    } = useComplianceTermsForm(showHistorical);

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons =
        complianceTerms && complianceTerms?.id ? true : false;

    return (
        <>
            <LayoutModule
                title="Detalle de Cumplimiento de términos PQR"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={complianceTerms?.id || ''}
                        buttonCreate={{
                            show: showActionButtons && !isOnlyViewProfile(type),
                            route: COMPLIANCE_TERMS_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: COMPLIANCE_TERMS,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: COMPLIANCE_TERMS_EDIT,
                        }}
                        buttonView={{
                            show: false,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <ComplianceTermsHistorical
                            historical={complianceTermsHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Interno"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <ComplianceTermsData
                        data={complianceTerms}
                        onChangeFormik={(formik) =>
                            setformikComplianceTermsData(formik)
                        }
                    />
                </LayoutModule>
            </LayoutModule>
            <ComplianceTermsRegisterHistory complianceTerms={complianceTerms} />
        </>
    );
};
